<style lang="less" scoped>
  @import "../../../style/theme.less";

  #menu {
    background: @layout-sider-background;
  }

  img {
    height: 32px;
    width: auto;
    left: 50%;
    position: relative;
    transform: translateX(-50%);
    margin-top: 16px;
    margin-bottom: 24px;
  }
</style>

<template>
  <div>
    <img v-if="siderCollapsed" src="../../../assets/logo_square.png" />
    <img v-else src="../../../assets/logo_wide.png" />

    <a-menu id="menu" theme="dark" mode="inline" :selectedKeys="selectedKeys" @click="click">

      <a-menu-item key="admin.submissions">
        <a-icon type="ordered-list" />
        <span>Submissions</span>
      </a-menu-item>

      <a-menu-item key="admin.normalisation-vectors">
        <a-icon type="vertical-align-middle" />
        <span>Normalisation Vectors</span>
      </a-menu-item>

      <a-menu-item key="admin.report-types">
        <a-icon type="snippets" />
        <span>Archetypes</span>
      </a-menu-item>

      <a-menu-item key="admin.users">
        <a-icon type="user" />
        <span>Admin Users</span>
      </a-menu-item>

    </a-menu>
  </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'layout-sider',

  data: () => ({
    selectedKeys: [],
  }),

  watch: {
    '$route.name': function (key) {
      this.updatedSelectedKey(key);
    },
  },

  computed: mapState('admin', ['siderCollapsed',]),

  mounted() {
    this.updatedSelectedKey(this.$route.name);
  },

  methods: {
    updatedSelectedKey(key) {
      const parts = key.split('.');
      this.selectedKeys = [`admin.${parts[1]}`,];
    },

    click({ key:name, }) {
      this.$router.push({ name, });
    },
  },
};
</script>
